<template>
    <div class="body-inner">
        <header-landing-component></header-landing-component>


        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
        
        <div class="slide kenburns" style="background-image:url('../../assets/images/certificaciones/csb_bg.jpg');">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="slide-captions text-center text-light">
                  
                    <span class="strong">Certificaciones</span>
                    <h1 class="text-shadow-dark">Communication Skills for Business<br>
<span style="font-size: 2.55rem">CSB</span></h1>
                   
                </div>
            </div>
        </div>
      

    </div>
   

    <section>
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="heading-text heading-section">
                        <h2 style="font-size: 2.85rem">EL ÉXITO ES DIRIGIDO POR EL PODER DE LA <span style="color:#FF4F00">COMUNICACIÓN</span></h2>

                    </div>
                    <img src="../../assets/images/certificaciones/csb.png">
                </div>
                <div class="col-lg-8">
                    <div class="row">
                        <div class="col-lg-10">
                            
                            En el lugar de trabajo de hoy, las habilidades interpersonales son fundamentales para lograr el éxito. Desarrollar habilidades interpersonales en el lugar de trabajo pueden dar
a los candidatos una gran ventaja en la competencia. Los departamentos de Educación técnico-profesional (Career Technical Education, CTE)
y de Educación y formación vocacional (Vocational Education and Training,
VET) lo saben, y muchas voces dentro del sector de la educación están promocionando la importancia de las habilidades interpersonales, que es lo que se considera que son las habilidades de comunicación.<br><br>
                            Tradicionalmente, en las certificaciones se han evitado las habilidades interpersonales, pero después de investigar y deliberar, se determinó que hay suficientes principios de comunicación que son ampliamente aceptados para que sea posible crear una certificación que pueda ser aceptada por la industria.
                            <br><br>
                        El examen CSB valida que los candidatos que ingresan a la fuerza laboral entienden los principios y habilidades de comunicación clave que son necesarios para ser eficaces en un ambiente de trabajo. Si bien la habilidad clave que se mide es la comunicación, la naturaleza de este examen también ayudará a los estudiantes con las otras 3 habilidades:
                            
                            <ul>
                                <li><strong>Pensamiento crítico:</strong> que sucederá cuando piensen en cómo comunicarse de manera eficaz.</li>
                                <li><strong>Colaboración:</strong> que derivará de una comunicación eficaz con otros.</li>
                                <li><strong>Creatividad</strong>: que se requiere para presentar comunicaciones atractivas.</li>
                            
                            </ul>
                            

                            <br>
                            
                            
                            
                        La certificación <strong>Communication Skills for Business</strong> está pensada para su uso principalmente en entornos académicos, incluidos entornos de educación secundaria y superior, pero también podría usarse para candidatos que necesiten mejorar sus habilidades para ingresar a la fuerza laboral. Estos candidatos pueden estar en instituciones y programas gubernamentales o de desarrollo, o pueden ser personas que buscan aumentar su empleabilidad por su cuenta. </div>

                     

                    </div>
                </div>

            </div>
            <div class="row mt-5">
                <div class="col-12 text-center">
                    <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                </div>
                <div class="col-12 text-center">
                    <img src="../../assets/images/carousel/Sample_Certificate_CSB.png" alt="">
                </div>
            </div>
        </div>
    </section>
    
    
<section class="bg-light">
     <div class="container">
        
        <div class="row">
            
            <div class="col-md-6">
                
                <h4>APRENDER, PRACTICAR, CERTIFICAR</h4>
                
                <p>El nivel de competencia esperado para
el examen se puede obtener a través de materiales de aprendizaje y evaluaciones de práctica de GMetrix. Una persona
que obtuvo esta certificación ha tenido aproximadamente 150 horas de instrucción y experiencia práctica en teoría y práctica formales de la comunicación.<br>
<br>
El nivel de conocimiento requerido para aprobar los exámenes se describe en los dominios meta. Estos dominios meta son la base de todos los materiales de aprendizaje, evaluaciones de práctica
y exámenes de certificación.</p>
                
                </div>
            
            <div class="col-md-6">
                
                <h4>OBJETIVOS DEL EXAMEN DE CERTIFICACIÓN CSB</h4>
                
                <p>El examen de certificación CSB es un examen de 50 minutos que consta de aproximadamente 35 a 50 preguntas que cubren los siguientes objetivos:</p>
                
                <ol>
                    
                    <li>Describir los principios básicos de la comunicación</li>
                    <li>Hacer planes para una comunicación eficaz</li>
                    <li>Aplicar las mejores prácticas para crear productos finales comerciales</li>
                    <li>Entregar su mensaje</li>
                    <li>Recibir comunicaciones</li>
                    <li>Analizar situaciones de comunicación</li>
                
                
                </ol>
                
            
                
                
                
</div>
            
            
            
          
           
        </div>
     </div>
    </section>	
    
    


    

    <!--call-to-action dark -->
    <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
        <div class="container">
            <div class="row">
                <div class="col-lg-10">
                    <h3>
                        ¿Quieres agregar esta credencial con validez internacional a tu CV?
                    </h3>
                    <p>
                        Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                    </p>
                </div>
                <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
            </div>
        </div>
    </div>
    <!--end: call-to-action dark -->


    <LeadComponent></LeadComponent>
        
        <footer-landing-component></footer-landing-component>
    </div>
</template>

<script>
  import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
  import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
  import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},            
		name: 'csb',
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>